import { TablePagination } from '@material-ui/core';
import React from 'react';

function TablePager({
    total,
    page,
    setPage,
    pageSize,
    setPageSize,
    pageOptions = [5, 10, 25, 50, 100, 150]
}) {
    if (!total) {
        return null;
    }
    return (
        <TablePagination
            rowsPerPageOptions={pageOptions}
            component="div"
            count={total}
            rowsPerPage={pageSize}
            page={page}
            backIconButtonProps={{
                'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
                'aria-label': 'Next Page'
            }}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={event => {
                setPageSize(+event.target.value);
                setPage(0);
            }}
        />
    );
}

export default TablePager;
